import { API_URLS } from 'config/constants';
import httpServices from './http.service';

export const getRedirects = () => (httpServices.get(API_URLS.REDIRECT.LIST));
export const getRedirect = (id) => (httpServices.get(API_URLS.REDIRECT.GET.replace('[id]', id)));
export const addRedirect = (data) => (httpServices.post(API_URLS.REDIRECT.CREATE, data));
export const updateRedirect = ({ id, payload }) => (httpServices.patch(API_URLS.REDIRECT.EDIT.replace('[id]', id), payload));
